<template>
  <Modal title="添加学生" v-model="visible">
    <Form
      ref="insertUserForm"
      class="form"
      :label-width="80"
      :model="insertUserParam"
      :rules="ruleUser"
    >
      <Row>
        <Col :span="22">
          <Form-item label="昵称" prop="nickname">
            <Input v-model="insertUserParam.nickname"></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="微信号" prop="wechatAccount">
            <Input v-model="insertUserParam.wechatAccount"  placeholder="手机号和微信号至少填一个"></Input>
          </Form-item>
        </Col>
        <Col :span="10">
              <Form-item label="区号" prop="areaNum">
                <PhoneAreaSelect @on-change="onAreaNumChange"></PhoneAreaSelect>
              </Form-item>
        </Col>
        <Col :span="13">
              <Form-item label="手机号码" prop="mobile">
                <Input v-model="insertUserParam.mobile" placeholder="手机号和微信号至少填一个"></Input>
              </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="密码" prop="password">
            <Input v-model="insertUserParam.password"></Input>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="性别" prop="sex">
            <Select v-model.number="insertUserParam.sex" transfer>
              <Option
                v-for="item in sexList"
                :value="item.code"
                :key="item.code"
                >{{ item.text }}</Option
              >
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="等级" prop="userInfoLevelId">
            <Select
              v-model.number="insertUserParam.userInfoLevelId"
              filterable
              transfer
              clearable
            >
              <Option
                v-for="item in bookMaterialLevelList"
                :value="item.id"
                :key="item.id"
                >{{ item.title }}</Option
              >
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="年龄" prop="age">
            <Input v-model.number="insertUserParam.age" type="number" :min="0" :max="150"></Input>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="渠道" prop="regType">
            <channel-select transfer v-model="insertUserParam.regType"></channel-select>
          </Form-item>
        </Col>
        <Col :span="11">
          <FormItem prop="adviserId" label="课程顾问：">
            <Select
              v-model.number="insertUserParam.adviserId"
              filterable
              clearable
              transfer
            >
              <Option
                v-for="item in adviserList"
                :value="item.adviserId"
                :key="item.adviserId"
              >{{ item.adviserName }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :span="22">
          <Form-item label="备注" prop="remark">
            <Input v-model="insertUserParam.remark"  :rows="3" type="textarea" ></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="上传截图" prop="url">
            <multiple-image-upload :num="100" :defaultFileList="defaultPicList" v-model="insertUserParam.files" on-file-change="onFileChange"/>
          </Form-item>
        </Col>
<!--        <Col :span="11">-->
<!--          <Form-item label="机构" prop="schoolId">-->
<!--            <Select v-model.number="insertUserParam.schoolId" transfer>-->
<!--              <Option-->
<!--                v-for="item in $constant.schoolEnums"-->
<!--                :value="item.code"-->
<!--                :key="item.code"-->
<!--              >{{ item.text }}</Option-->
<!--              >-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </Col>-->
        <Col :span="11" v-if="insertUserParam.regType === 'tj'">
          <Form-item label="推荐学生Id" prop="inviteId">
            <Input v-model.number="insertUserParam.inviteId"></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible = false">取消</Button>
      <Button
        type="primary"
        size="large"
        :loading="loadingInsertUser"
        @click="insertUser"
        >保存</Button
      >
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'InsertUserModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    let $constant = this.$constant
    // let self = this
    return {
      visible: this.value,
      userListStatusList: $constant.userListStatus,
      regTypes: $constant.studentCanal,
      sexList: $constant.sex,
      bookMaterialLevelList: null,
      loadingInsertUser: false,
      defaultPicList: [],
      adviserList: [],
      insertUserParam: {
        areaNum: 86,
        nickname: '',
        wechatAccount: '',
        mobile: '',
        password: '',
        sex: 1,
        regType: '',
        adviserId: 0,
        inviteId: '',
        schoolId: 0,
        remark: '',
        files: ''
      },
      ruleUser: {
        nickname: [
          { type: 'string', required: true, message: '昵称不能为空', trigger: 'blur' },
          { type: 'string', min: 1, max: 20, message: '昵称应为1-20个字', trigger: 'blur' }
        ],
        mobile: [
        ],
        regType: [
          { type: 'string', required: false, message: '渠道不能为空', trigger: 'blur' }
        ],
        inviteId: [
          { type: 'number', required: true, message: '推荐ID不能为空' }
        ]
      },
    }
  },
  methods: {
    insertUser () {
      let self = this
      self.loadingInsertUser = true

      // 在提交前检查regType是否为空
      if (!self.insertUserParam.regType) {
        self.$Message.warning('渠道不能为空!');
        self.loadingInsertUser = false
        return
      }

      self.$refs.insertUserForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingInsertUser = false
          return
        }
        if (self.insertUserParam.mobile !== '' && self.insertUserParam.areaNum !== undefined && self.insertUserParam.areaNum !== 86) {
          self.insertUserParam.mobile = '00' + self.insertUserParam.areaNum + '-' + self.insertUserParam.mobile
        }
        self.$http.post('/user/bopsInsert', self.insertUserParam).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false
            self.$Message.success('提交成功!')
            self.successCallback()
          }
          self.loadingInsertUser = false
        }).catch(function (e) {
          self.showInsertUserModal = false
          self.loadingInsertUser = false
        })
      })
    },
    loadBookMaterialLevel () {
      let self = this
      if (self.bookMaterialLevelList) {
        return
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.bookMaterialLevelList = res.data
      })
    },
    getAdviserList () {
      let self = this
      self.adviserList = []
      self.$http.get('/adviser/listNoPage').then(function (res) {
        if (res && res.data) {
          self.adviserList = res.data
        }
      })
    },
    onAreaNumChange (val) {
      this.insertUserParam.areaNum = val
    },
  },
  watch: {
    value (val) {
      this.visible = val
    },
    visible (val) {
      let lastRegType = this.insertUserParam.regType
      if (val === true) {
        // 移除重置regType的逻辑，保留其他字段的重置
        this.insertUserParam = {
          areaNum: 86,
          nickname: '',
          wechatAccount: '',
          mobile: '',
          password: '',
          sex: 1,
          regType: lastRegType,  // 不再清空渠道字段
          adviserId: 0,
          inviteId: '',
          schoolId: 0,
          remark: '',
          files: ''
        }
        this.defaultPicList = []
        this.loadBookMaterialLevel()
        this.getAdviserList()
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// InsertUserModal.vue?e7a0c6bc